import { AbstractControl, ValidationErrors } from '@angular/forms';
export class SicAniaValidators {

  // composite validator
  static searchFormValidator(control: AbstractControl): ValidationErrors | null {
    const validateFn = () : boolean => {
      const plate = control.get('plate')?.value;
      if (plate === null) return true;
      return plate.length &&  /^[A-Za-z\d*]+$/gm.test(plate);
    }
    return SicAniaValidators.dependentResultManager(validateFn, control, ['plate'], 'invalid_license')
  }

  // Utilities
  private static dependentResultManager(validateFn: () => boolean, form: AbstractControl, controlNames: string[], errorKey: string) {
    const result: ValidationErrors = {};
    const isValid = validateFn();
    controlNames.forEach((controlName) => {
      SicAniaValidators.updateControlErrors(form.get(controlName), errorKey, isValid);
    });
    if (isValid) {
      return null;
    }

    result[errorKey] = true;
    return result;
  }

  private static updateControlErrors(control: AbstractControl | null, errorKey: string, isValid: boolean): void {
    if (!control) {
      return;
    }
    let errors: ValidationErrors | null | undefined = control?.errors;
    if (errors && isValid) {
      delete errors[errorKey];
      errors = Object.keys(errors).length ? errors : null;
    }

    if (!isValid) {
      errors = errors || {};
      errors[errorKey] = true;
    }
    control.setErrors(errors);
  }
}
